
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { POST } from '../../../helpers/httphelper';
import { toast as superToast } from 'bulma-toast'

function MedicinesFormAll() {
    const [keyword, setKeyword] = useState('');
    const [date, setDate] = useState('');
    const [medicineAll, setMedicineAll] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const UserID = localStorage.getItem('user');

    const endDate = useRef();

    useEffect(() => {

        const pr = POST('api/medicine/filter', { keyword, date, UserID })
            .then(res => {
                console.log(res);
                setMedicineAll(res);
            }).catch(err => {
                console.log(err);
            });

        // set isLoading to false after the data is loaded
        Promise.all([pr]).then(() => {
            setIsLoading(false);
        });
    }, [keyword, date, UserID])

    console.log(medicineAll);

    const info = []
    medicineAll.forEach((element, _index, _array) => {
        info.push(
            [
                element.Channeling ? element.Channeling : 'N/A',
                element.Description ? element.Description : 'N/A',
                element.Dosage ? element.Dosage : 'N/A',
                element.Frequency ? element.Frequency : 'N/A',
                element.StartDate ? element.StartDate : 'N/A',
                element.EndDate ? element.EndDate : 'N/A',
                element.MedicineTime[0]?.Morning[0]?.Morning ? 'Yes' : '---',
                element.MedicineTime[0]?.Morning[0]?.MorningTime ? element.MedicineTime[0]?.Morning[0]?.MorningTime : '---',
                element.MedicineTime[0]?.Noon[0]?.Noon ? 'Yes' : '---',
                element.MedicineTime[0]?.Noon[0]?.NoonTime ? element.MedicineTime[0]?.Noon[0]?.NoonTime : '---',
                element.MedicineTime[0]?.Night[0]?.Night ? 'Yes' : '---',
                element.MedicineTime[0]?.Night[0]?.NightTime ? element.MedicineTime[0]?.Night[0]?.NightTime : '---',
            ])
    })

    const generateReport = () => {
        const doc = new jsPDF({
            orientation: "landscape",
            unit: "in",
            format: "a3",
        });
        autoTable(doc, {
            head: [['Channeling', 'Description', 'Dosage', 'Frequency', 'Start Date', 'End Date', 'Morning', 'Morning Time', 'Noon', 'Noon Time', 'Night', 'Night Time'/* , 'Image' */]],
            body: info,
            // theme: 'grid',
            headStyles: {
                fillColor: [123, 200, 255],
            },
            // styles: {
            //     overflow: 'linebreak',
            //     fontSize: 8,
            //     cellPadding: 2,
            //     halign: 'center',
            //     valign: 'middle',
            // },
        })
        doc.save('Medicine Report.pdf');
        superToast({
            message: 'Report Downloaded',
            type: 'is-warning',
            dismissible: true,
            position: "top-center",
            animate: { in: 'fadeIn', out: 'fadeOut' },
        })
    };

    return (
        <div>
            <div className='columns'>
                <div className='column is-9'>
                    <div className='mb-5'>
                        <h1 className="title is-3 is-light is-semibold is-spaced main-title is-justify-content-center is-flex "> Medicine List</h1>
                    </div>
                    <div className='columns is-multiline is-align-content-flex-start' style={{ height: '75vh', overflow: 'scroll' }}>
                        {isLoading ?
                            <div className='column is-12 has-text-centered'>
                                <div className="container mt-4">
                                    <div className="notification is-success title is-3">
                                        <b> Loading  Medicine... </b>
                                        {/* rotating loading icon from bulma */}
                                        <span className="icon is-large">
                                            <i className="fas fa-sync-alt fa-spin" />
                                        </span>
                                    </div>
                                </div>
                            </div>
                            :
                            (medicineAll.length > 0) ? (medicineAll?.map((medicine, index) => (
                                <div key={index} className='column is-4'>
                                    <Link to={`/medicines/view/${medicine._id}`}>
                                        <div className='card' style={{ backgroundColor: '#EFEFEF', borderRadius: '25px' }}>
                                            <div className='is-flex' style={{ backgroundColor: '#7BC8FF', borderRadius: '25px 25px 0px  0px' }}>
                                                <div className='ml-4 mt-4 mb-4 title is-3'>
                                                    <i className="fa-solid fa-capsules"></i>
                                                </div>
                                                <div className='ml-5 mt-4 mb-4 title is-4'>
                                                    {medicine?.MedicineName}
                                                </div>
                                            </div>
                                            <div className='m-2 p-2'>
                                                <h1 className="subtitle is-4 is-light is-semibold is-spaced main-title is-justify-content-center is-flex ">{medicine?.Channeling}</h1>
                                                <div className='is-justify-content-space-between is-flex'>
                                                    <div>
                                                        {medicine?.StartDate}
                                                    </div>
                                                    <div>
                                                        {medicine?.Dosage}
                                                    </div>
                                                </div>
                                                <div className='is-justify-content-space-between is-flex'>
                                                    <div>
                                                        {medicine?.EndDate}
                                                    </div>
                                                    <div>
                                                        {medicine?.Frequency}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            ))) : (<div>No Medicine Found</div>)}

                    </div>
                </div>
                <div className='column is-3'>
                    <div className='card' style={{ minHeight: '100%', backgroundColor: '#D9D9D9', borderRadius: '50px' }}>
                        <div className='is-justify-content-center is-flex pt-6'>

                            <Link to="/medicines/add">
                                <button className='button is-link is-rounded' style={{ backgroundColor: '#7BC8FF' }}>
                                    <span className="icon">
                                        <i className="far fa-file-pdf"></i>
                                    </span>
                                    <span>Add New</span>
                                </button>
                            </Link>
                        </div>
                        <div className='card mt-6 ml-4 mr-4' style={{ height: '45vh', borderRadius: '50px' }}>
                            <div className='pt-5 is-justify-content-center is-flex '>
                                <h1 className="title is-4 is-light is-semibold is-spaced main-title "> Medicine List</h1>
                            </div>
                            <div className='pt-4 pl-3 pr-3' >
                                <div className='mt-6'>
                                    <input className="input mt-3"
                                        ref={endDate}
                                        type="text"
                                        placeholder='Date'
                                        onChange={(e) => setDate(e.target.value)}
                                        onFocus={() => (endDate.current.type = "date")}
                                        onBlur={() => (endDate.current.type = "text")}
                                    />
                                </div>
                                <div className='mt-6'>
                                    <input className='input' placeholder='Search by medication' type='text' onChange={(e) => setKeyword(e.target.value)} />
                                </div>
                            </div>

                        </div>
                        <div className='is-justify-content-center is-flex mt-6'>
                            <button style={{ backgroundColor: '#6AF154' }} className="button is-link is-rounded mb-3" onClick={() => generateReport()}>
                                <span className="icon">
                                    <i className="far fa-file-pdf"></i>
                                </span>
                                <span>Get Report</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MedicinesFormAll